// extracted by mini-css-extract-plugin
export default {"inputWrap":"Forgot_inputWrap__gb788"};